
// export const USER_NAME = "test_user";
export const USER_NAME = sessionStorage.getItem("username");

export const API_SERVER_URL = "https://quicsnap--aux-free-x4-model-all-functions.modal.run";

export const MAIL_API_INVOKE_URL = "https://19s3s5xa40.execute-api.us-east-1.amazonaws.com";

export const PROFILE_USER_AVATAR = "https://img.icons8.com/?size=100&id=fUUEbUbXhzOA&format=png&color=000000";

// export const monthlyPrices = ["$0", "$50", "$100", "$250"];
export const monthlyPrices = ["$0", "$100", "$200", "$500"];
// export const yearlyPrices = ["$0", "$40", "$80", "$200"];
export const yearlyPrices = ["$0", "$100", "$200", "$500"];

export const planFeatures = {
  "Free Plan": [
    "100 credits",
    "Low priority in generation queue",
    "1K resolution output",
    "Storage in cloud gallery: 15 days",
    "Upscaling to 2K",
    "Editing tools",
    "Support channel: Community forum",
    "Only for new user"
  ],
  "Basic Plan": [
    "250 credits",
    "Credits per $: 5",
    "Normal priority in generation queue",
    "1K resolution output",
    "Storage in cloud gallery: 90 days",
    "Upscaling to 2K",
    "Editing tools",
    "Commercial usage licence",
    "Support channel: Standard email (24 h SLA)"
  ],
  "Standard Plan": [
    "600 credits",
    "Credits per $: 6",
    "Medium priority in generation queue",
    "1K resolution output",
    "Storage in cloud gallery: 180 days",
    "Upscaling to 2K",
    "Editing tools",
    "Commercial usage licence",
    "One-on-One On-boarding: 1X 30-min call",
    "Support channel: Priority email/chat (8 h SLA)"
  ],
  "Premium Plan": [
    "1750 credits",
    "Credits per $: 7",
    "Highest / dedicated lane priority in generation queue",
    "1K resolution output",
    "Storage in cloud gallery: Unlimited",
    "Upscaling to 2K",
    "Editing tools",
    "Commercial usage licence",
    "One-on-One On-boarding: Dedicated CSM + Monthly Sessions",
    "Support channel: 24 X 7 chat / phone (2 h SLA)",
    "Early / beta feature access",
    "New Feature Voting"
  ]
};


